.container {
  border: 2px solid var(--blue);
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
}

.titleNormal {
  padding: 0;
}

.titleLarge {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 0;
}

.container.alternative {
  background-color: #e7f2f7;
}

.tooltipContainer {
  height: 65px;
  position: relative;
  display: inline-block;
}

.tooltipContent {
  visibility: visible;
  width: 300px;
  background-color: var(--blue);
  color: #fff;
  font-size: small;
  text-align: center;
  padding: 4px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.9;
  pointer-events: none;
}

.text {
  margin: 8px 0;
}

.content {
  p {
    margin: 0 0 8px;
  }

  a {
    margin-left: 1rem;
  }

  &>div {
    display: flex;
    justify-content: flex-end;
  }
}

.iconTextFlex {
  display: flex;
  flex-direction: row;
  align-items: center;

  p {
    margin: 0;
  }
}